/*
 * Bouton d'achat epingle, Ruban Paris.
 *
 * LE DEFAUT CORRIGE. Jusqu'au 20 aout, la regle CSS epinglait le bouton des le
 * chargement sous 900px. Il quittait donc le flux et n'apparaissait JAMAIS sous
 * le selecteur d'offre. Mesure : position fixed, bouton a -96px du haut du
 * document a 375px de large, alors qu'a 1440px il etait bien en static juste
 * sous le bundle. Vu de l'exterieur, ca se lit comme un bouton supprime.
 *
 * DESORMAIS. Le bouton reste dans le flux, a sa place sous le selecteur d'offre.
 * Ce script pose la classe rp-atc-fixe sur body a partir du moment ou la
 * premiere section sous la fiche entre dans l'ecran, c'est-a-dire
 * "Pourquoi ce cadeau est si special". C'est la seule chose que fait le script :
 * l'epinglage lui-meme reste en CSS, dans rp-responsive.css.
 *
 * LA CALE. Passer en position fixed sort le bouton du flux : sans compensation,
 * tout ce qui se trouve en dessous remonterait d'un coup de sa hauteur, soit un
 * saut de 70px sous les yeux de la visiteuse. On insere donc une cale vide juste
 * avant le conteneur, a laquelle on donne la hauteur du bouton au moment ou il
 * s'epingle. La hauteur est mesuree AVANT d'ajouter la classe, sinon on
 * mesurerait un element deja sorti du flux.
 *
 * Volontairement un ecouteur de scroll avec verrou, et non un
 * IntersectionObserver : ce theme a deja un historique de moteurs qui n'honorent
 * ni rAF ni le chargement differe (pieges 14 et 27), et un simple test de
 * position est verifiable a la main.
 */
(function () {
  'use strict';

  var CLASSE = 'rp-atc-fixe';
  var mq = window.matchMedia('(max-width: 900px)');

  function init() {
    var btn = document.querySelector('.rp-atc');
    if (!btn) return;
    var boite = btn.closest('.rp-b');
    if (!boite || boite.dataset.rpSticky) return;
    boite.dataset.rpSticky = '1';

    var cale = document.createElement('div');
    cale.className = 'rp-atc-cale';
    cale.setAttribute('aria-hidden', 'true');
    boite.parentNode.insertBefore(cale, boite);

    /*
     * Repere de declenchement : la premiere section sous la fiche produit. Sur le
     * gabarit produit c'est "Pourquoi ce cadeau est si special". Repli sur le
     * conteneur du bouton lui-meme si le gabarit change.
     */
    var repere = document.querySelector('.rp-its') || boite;

    var actif = false, enAttente = false;

    function appliquer() {
      var doit = mq.matches && repere.getBoundingClientRect().top <= window.innerHeight;
      if (doit === actif) return;
      actif = doit;
      if (doit) {
        cale.style.height = boite.offsetHeight + 'px';
        document.body.classList.add(CLASSE);
      } else {
        document.body.classList.remove(CLASSE);
        cale.style.height = '';
      }
    }

    function planifier() {
      if (enAttente) return;
      enAttente = true;
      setTimeout(function () { enAttente = false; appliquer(); }, 80);
    }

    window.addEventListener('scroll', planifier, { passive: true });
    window.addEventListener('resize', planifier);
    if (mq.addEventListener) mq.addEventListener('change', planifier);

    /* Expose pour pouvoir controler l'etat depuis la console, sans defiler. */
    window.rpStickyAtc = { appliquer: appliquer, etat: function () { return actif; } };

    appliquer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* L'editeur de theme re-injecte les sections sans recharger la page. */
  document.addEventListener('shopify:section:load', init);
})();
